import React from 'react';
import { instanceOf, number, string } from 'prop-types';
import moment from 'moment';
import { useFormik } from 'formik';

import DateField from '../../components/FormFields/DateField';
import validationSchema from './AgentLogTimestampFilter.schema';

const AgentLogTimestampFilter = ({
    dateFormat,
    endTimestamp,
    endTimestampDisabled = false,
    maxDate,
    minDate,
    onFilterChange,
    showTimeSelect,
    startTimestamp,
    startTimestampDisabled = false,
    timeFormat,
    timeIntervals
}) => {

    const {errors, touched, values, ...form} = useFormik({
        enableReinitialize: true,
        initialTouched:     {
            endTimestamp:   true,
            startTimestamp: true
        },
        initialValues: {
            endTimestamp:   endTimestamp,
            startTimestamp: startTimestamp
        },
        validateOnBlur: false,
        validationSchema
    });

    /**
     * Modifies the appropriate timestamp value based on the value of the
     * changed requisite date or time input.
     */
    function handleChange(name) {
        return (value, event) => {
            let parsedValue = null;
            if (value) {
                parsedValue = moment(value);
                form.setFieldValue(name, parsedValue, false);
            }
            form.setFieldTouched(name, true, false);
            onFilterChange(name, parsedValue, value);
            form.validateForm();
        };
    }

    return (
        <>
            <DateField
                dateFormat={dateFormat}
                isClearable={!startTimestampDisabled}
                label="Start Time"
                margin="dense"
                maxDate={new Date()}
                minDate={new Date(2015,0,1)}
                name="startTimestamp"
                onChange={handleChange('startTimestamp')}
                showTimeSelect={showTimeSelect}
                timeFormat={timeFormat}
                timeIntervals={timeIntervals}
                value={values.startTimestamp.toDate()}
                disabled={startTimestampDisabled}
            />
            <DateField
                dateFormat={dateFormat}
                errors={errors.endTimestamp}
                isClearable={!endTimestampDisabled}
                label="End Time"
                margin="dense"
                maxDate={new Date()}
                minDate={new Date(2015,0,1)}
                name="endTimestamp"
                onChange={handleChange('endTimestamp')}
                showTimeSelect={showTimeSelect}
                timeFormat={timeFormat}
                timeIntervals={timeIntervals}
                touched={touched.endTimestamp}
                value={values.endTimestamp.toDate()}
                disabled={endTimestampDisabled}
            />
        </>
    );
};

AgentLogTimestampFilter.defaultProps = {
    dateFormat:     'yyyy-MM-dd h:mm a',
    showTimeSelect: true,
    timeFormat:     'h:mm a',
    timeIntervals:  15
};

AgentLogTimestampFilter.propTypes = {
    dateFormat:     string,
    endTimestamp:   instanceOf(moment).isRequired,
    startTimestamp: instanceOf(moment).isRequired,
    timeFormat:     string,
    timeIntervals:  number
};

export default AgentLogTimestampFilter;
